import { QueryKey } from "@tanstack/react-query";
import _ from "lodash";

import { getDependentModels } from "./getDependentModels";
import { parseOpQueryKey } from "./getOpQueryKey";
import { ObjectPoolModelToStateGraphConfig } from "./queries";

export function getShouldInvalidateBroadQuery(
  models: Array<keyof ObjectPoolModelToStateGraphConfig>,
) {
  const modelsSet = new Set(models);

  function shouldInvalidateBroadQuery(queryKey: QueryKey) {
    const parsedQueryKey = parseOpQueryKey(queryKey);

    if (!parsedQueryKey) return false;

    // If no models are provided, invalidate all queries
    if (modelsSet.size === 0) return true;

    const { objectName, paramsStr } = parsedQueryKey;

    const params = JSON.parse(paramsStr);
    const dependentModels = getDependentModels(objectName, params);
    const result = _.intersection(Array.from(dependentModels), Array.from(modelsSet)).length > 0;

    if (params.debug) console.log("shouldInvalidateBroadQuery", queryKey, result);
    return result;
  }
  return shouldInvalidateBroadQuery;
}
